import Model from '@/models/Model'
import SaleUtils from '@/services/SaleUtils'
import WhPackModel from '@/models/Warehouse/WhPack'

export default class WhProduct extends Model {
    static includes = ['sl_wholesale_discounts']
    static appends = [
        'sale_prices',
        'stocks',
        'branch_offices',
        'composition',
        'type_wholesale_discount',
        'sale_price_by_branch_office',
    ]

    branchOfficeId = 0

    resource() {
        return 'wh_product'
    }

    get firstUPC() {
        if (!this.upc_codes || !this.upc_codes.length) return
        return this.upc_codes[0]
    }

    get officePrice() {
        if (!this.activeOffice) return 'seleccione oficina'
        if (!this.sale_prices || !this.sale_prices.length)
            return 'no hay precios configurados'
        let price = this.sale_prices.find(
            sp => sp.branch_office_id === this.activeOffice
        )
        if (!price) return 'no hay precio configurado en esta oficina'
        return price.sale_price
    }

    get officeCostPrice() {
        if (!this.activeOffice) return 'seleccione oficina'
        if (!this.branch_offices || !this.branch_offices.length)
            return 'no hay precios configurados'
        let cost = this.branch_offices.find(
            off => off.g_branch_office_id === this.activeOffice
        )
        if (!cost) return 'no hay precio configurado en esta oficina'
        return cost.cost_price
    }

    get officeNetPrice() {
        if (!this.officePrice || isNaN(this.officePrice)) return 'error'
        return Math.round(this.officePrice / 1.19)
    }

    get officeMargin() {
        // if (
        //     !this.officeCostPrice ||
        //     isNaN(this.officeCostPrice) ||
        //     !this.officeNetPrice ||
        //     isNaN(this.officeNetPrice)
        // )
        //     return 'error'
        // return Number((this.officeNetPrice - this.officeCostPrice) / this.officeNetPrice).toFixed(2)
        let branch = this.branch_offices.find(b=>b.g_branch_office_id === this.activeOffice)
        return Number(branch.gains_margin)
        
    }

    get newPrice() {
        if (!this.newNetPrice || isNaN(this.newNetPrice)) return 'error'
        return Math.round(this.newNetPrice * 1.19)
    }

    get newNetPrice() {
        if (
            !this.officeCostPrice ||
            isNaN(this.officeCostPrice) ||
            !this.newMargin ||
            isNaN(this.newMargin)
        )
            return 'error'
        return Math.round(parseInt(this.officeCostPrice) * (this.newMargin/100)+parseInt(this.officeCostPrice))
        // let branch = this.branch_offices.find(b=>b.g_branch_office_id === this.activeOffice)
        // return Number(branch.cost_price)
    }

    findBranchOffice = branch_office => {
        return branch_office.g_branch_office_id == this.branchOfficeId
    }

    findSalePrice = sale_price => {
        return sale_price.branch_office_id == this.branchOfficeId
    }

    get criticalStockItem() {
        try {
            const branch_office = this.branch_offices.find(
                this.findBranchOffice
            )
            return branch_office ? branch_office.critical_stock : 0
        } catch (e) {
            return `e cr: ${e}`
        }
    }

    get costPriceItem() {
        try {
            const branch_office = this.branch_offices.find(
                this.findBranchOffice
            )
            return branch_office ? branch_office.cost_price : 0
        } catch (e) {
            return `e: ${e}`
        }
    }

    get salePriceItem() {
        try {
            const sale_price = this.sale_prices.find(this.findSalePrice)
            return sale_price ? sale_price.sale_price : 0
        } catch (e) {
            return `e: ${e}`
        }
    }

    get marginItem() {
        try {
            const branch_office = this.branch_offices.find(
                    this.findBranchOffice
                )
                
            return (branch_office)
                ? parseFloat(branch_office.gains_margin) + ' %'
                : 0
        } catch (e) {
            return `e: ${e}`
        }
    }

    get suggest_internal_code_params() {
        return {
            family_id: Number(this.wh_family_id || 1),
            product_name: String(this.name || ''),
            subfamily_id: Number(this.wh_subfamily_id || 1),
        }
    }

    get new_gain_margin() {

        //
        const newSalePrice = this.getProperty('new_sale_price', 0)
        const salePrice = this.getProperty('sale_price_by_branch_office', 0)
        const costPrice = this.getProperty('costPriceItem', 0)

        //
        return SaleUtils.getNewMargin(newSalePrice || salePrice, costPrice)
    }

    /**
     * Return the last product price amount
     * @type {string}
     */
    get last_purchase_price_amount() {
        return this.getProperty('last_purchase_price', '0')
    }

    /**
     * Return the last product provider alias name
     * @type {string}
     */
    get last_purchase_provider_alias_name() {
        return this.getProperty('last_purchase_provider.alias_name', 'Sin ultimo proveedor.')
    }

    /**
     * Return the last product provider alias name
     * @type {string}
     */
    get wh_pack_item_quantity() {
        return this.getProperty('wh_pack.item_quantity', 0)
    }

    toPack() {
        return new WhPackModel(this)
    }
}
